import { lazy } from 'react';

import { authRoles } from 'app/auth';

const BroadcastsList = lazy(() => import('../broadcasts/use-cases/broadcasts-list'));
const CreateBroadcast = lazy(() => import('../broadcasts/use-cases/create-broadcast'));

// Canada only registers the broadcasts routes from the marketing station — the rest of
// MarketingCampaigns (notifications, SMS campaigns) is UK-only, so we don't pull that config in.
const CanadaBroadcastsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            background: 'featured',
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'campaigns/broadcasts',
      element: <BroadcastsList />,
      auth: authRoles.pharmacist,
    },
    {
      path: 'campaigns/broadcasts/create',
      element: <CreateBroadcast />,
      auth: authRoles.pharmacist,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                // Mounted but hidden so pharmacy selection still initialises on direct page load
                pharmacySelector: true,
                pharmacySelectorHidden: true,
              },
            },
          },
        },
      },
    },
  ],
};

export default CanadaBroadcastsConfig;
